import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from '@elevio/kb-kit/lib/App';
import config from './config';
import './css/styles.css';
import './css/2023-restyle.css';
import SimpleReactLightbox from 'simple-react-lightbox';
const target = document.getElementById('kb-target');
if (!target) throw new Error('Cant find target div');
ReactDOM.render(
  <SimpleReactLightbox>
    <App config={config} />
  </SimpleReactLightbox>,
  target
);
